var slick_slider = $('.mobile-slick-slider');
$(window).load(function() {  
  if(slick_slider.length){
    settings = {
      arrows: true,
      slidesToShow: 1,
      slidesToScroll: 1,
    }

    if ($(window).width() < 768) {
       slick_slider.slick(settings);
    }

    // reslick only if it's not slick()
    $(window).on('resize', function() {
      if ($(window).width() > 768) {
        if (slick_slider.hasClass('slick-initialized')) {
          slick_slider.slick('unslick');
        }
        return
      }

      if (!slick_slider.hasClass('slick-initialized')) {
        return slick_slider.slick(settings);
      }
    });


    /*if ($(window).width() < 426) {
     $(".tp-bgimg").each(function() {
      console.log($('input:hidden[name=mobile-rev-image]').val());
      var imageUrl = $('input:hidden[name=mobile-rev-image]').val();
      $(this).css('background-image', 'url(' + imageUrl + ')');
    }); 
   }*/ 
  }
  
});  
